import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import docReady from '../../../assets/js/docReady';

import Mixins from '../../vue-elements/comparison-lib/mixins';
import InternetMixins from '../../shared/internetComparer/lib/mixins';

import router from '../../shared/internetComparer/router/router';
import InternetComparison from '../../shared/internetComparer/internetComparison.vue';

docReady(() => {
    const mountPoint = document.getElementById('internetComparison');

    if (mountPoint) {
        const pinia = createPinia();

        const compareModule = createApp(
            InternetComparison,
        );
        compareModule.use(pinia);
        compareModule.use(router);
        compareModule.use(autoAnimatePlugin);
        compareModule.mixin(Mixins());
        compareModule.mixin(InternetMixins());
        compareModule.mount(mountPoint, !window.location.pathname.includes('/vergelijken'));
    }
});
